import { useId } from "react";

import { ReviewCard } from "../../../../domain/ReviewCard.js";
import { Section } from "../../../../patterns/Section.js";
import { SectionHeader } from "../../../../patterns/SectionHeader.js";
import type { ReviewsContent } from "../../homeContent.js";

/** Shoppers' reviews; nothing for none. */
export function HomeReviews(reviews: ReviewsContent) {
  const id = useId();
  if (reviews.items.length === 0) return null;
  return (
    <Section aria-labelledby={id} className="flex flex-col gap-6">
      <SectionHeader
        title={reviews.title}
        titleId={id}
        subtitle={reviews.subtitle}
        action={reviews.viewAll}
      />
      <ul className="grid gap-3 md:grid-cols-2 md:gap-5 lg:grid-cols-4">
        {reviews.items.map(({ id: key, ...review }) => (
          <li key={key}>
            <ReviewCard {...review} className="h-full" />
          </li>
        ))}
      </ul>
    </Section>
  );
}
